<div class="container qai-auth-container  d-flex align-items-center justify-content-center">
    <div class="card p-4 shadow">
        <div class="card-body p-5 pt-2 pb-2">
            <h3 class="card-title my-5 text-center fw-bold" i18n>Verifica a due fattori</h3>

            <form [formGroup]="otpForm" (ngSubmit)="validateOtp()" (paste)="onPaste($event)">
                <div class="otp-field">
                    @for (item of (otpForm.controls | keyvalue); track $index) {
                    <input type="text" class="form-control fs-5" maxlength="1" formControlName="otp{{$index}}"
                        (input)="onInput($event, $index)" (keyup)="onBackspace($event, $index)" #otpInput />
                    }
                </div>
                <div class="form-text text-center pt-2 pb-5" id="optHelp" i18n>
                    @if (otpProcessFailed) {
                        Si è verificato un errore durante il processo di verifica OTP. 
                        <!-- Reinvia il codice per riprovare. -->
                    } @else {
                    @if (totalSeconds() > 0 && !isOTPExpired) {
                            Inserisci il codice di verifica ricevuto via email.
                            <br />Il codice OTP scade tra: {{ minutesSeconds() }}
                        } @else {
                            Il codice OTP è scaduto. Reinvia il codice per riceverne uno nuovo.
                        }
                    }
                </div>

                <div class="d-flex flex-column justify-content-center align-items-center">
                    <app-loading-button [loading]="loading()" [disabled]="otpForm.invalid || loading()"
                        i18n>Verifica</app-loading-button>
                    <div class="text-center pt-2">
                        <button type="button" class="btn btn-link btn-sm" id="resendBtn" (click)="resendOTP()">Reinvia
                            codice</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>